/**
 * Generic popup system
 *
 * Usage:
 *   - Trigger:  data-popup-trigger="my-popup"
 *   - Target:   data-popup="my-popup"
 *   - Close btn inside popup: data-popup-close (optional)
 *
 * The popup overlay itself also closes on click outside .popup-inner.
 *
 * Events dispatched on the overlay element:
 *   - popup:open
 *   - popup:close
 */

const Popup = (() => {
    'use strict';

    /**
     * Open a popup by its ID.
     * @param {string} id
     */
    function open(id) {
        const el = document.querySelector(`[data-popup="${id}"]`);
        if (!el) return;

        el.classList.add('is-open');
        document.body.classList.add('overflow-hidden');
        el.dispatchEvent(new CustomEvent('popup:open', { bubbles: true }));
    }

    /**
     * Close a popup by its ID (or its DOM element).
     * @param {string|HTMLElement} idOrEl
     */
    function close(idOrEl) {
        const el = typeof idOrEl === 'string'
            ? document.querySelector(`[data-popup="${idOrEl}"]`)
            : idOrEl;
        if (!el) return;

        el.classList.remove('is-open');
        document.body.classList.remove('overflow-hidden');
        el.dispatchEvent(new CustomEvent('popup:close', { bubbles: true }));
    }

    function init() {
        // Triggers externes
        document.querySelectorAll('[data-popup-trigger]').forEach(trigger => {
            trigger.addEventListener('click', () => {
                open(trigger.dataset.popupTrigger);
            });
        });

        // Fermeture : clic sur l'overlay (en dehors du .popup-inner)
        document.querySelectorAll('[data-popup]').forEach(popup => {
            popup.addEventListener('click', e => {
                if (!e.target.closest('.popup-inner')) {
                    close(popup);
                }
            });
        });

        // Fermeture : boutons [data-popup-close] à l'intérieur du popup
        document.querySelectorAll('[data-popup-close]').forEach(btn => {
            btn.addEventListener('click', () => {
                const popup = btn.closest('[data-popup]');
                if (popup) close(popup);
            });
        });

        // Fermeture : touche Échap
        document.addEventListener('keydown', e => {
            if (e.key === 'Escape') {
                document.querySelectorAll('[data-popup].is-open').forEach(popup => {
                    close(popup);
                });
            }
        });
    }

    return { init, open, close };
})();

export default Popup;
